import { Box, Typography, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants, post } from "../../../common/constants";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ImageIcon from '@mui/icons-material/Image';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, SUBTLE, BORDER, PRIMARY_BLUE } from '../../../styles/foundation/colors';

function QcDetails({ data }) {
    const [qcData, setQcData] = useState();
    const expiredUrl = data.qcDetails?.images?.find((elem) => elem.signedURLExpired === true);

    useEffect(() => {
        if (expiredUrl) {
            post(`${apiConstants.BASE_LOCAL}${apiConstants.REFRESH_S3_URL}`, data.qcDetails?.images).then((res) => {
                setQcData(res.data?.responseObj);
            }).catch((err) => {
                console.log(err);
            });
        } else {
            setQcData(data?.qcDetails?.images);
        }
    }, [expiredUrl]);

    if (!qcData || qcData.length === 0) {
        return (
            <Box sx={{ py: 3, textAlign: 'center' }}>
                <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>
                    No QC images available
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {qcData.map((item, index) => (
                <Box
                    key={index}
                    component="a"
                    href={item?.signedLink}
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        p: 1.5, borderRadius: 1, border: `1px solid ${BORDER}`,
                        textDecoration: 'none', cursor: 'pointer',
                        transition: 'background-color 0.15s',
                        '&:hover': { bgcolor: '#f5f8ff', borderColor: PRIMARY_BLUE },
                    }}
                >
                    <ImageIcon sx={{ fontSize: 20, color: SUBTLE }} />
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.medium, color: NAVY, flex: 1 }}>
                        QC Image {index + 1}
                    </Typography>
                    <OpenInNewIcon sx={{ fontSize: 16, color: PRIMARY_BLUE }} />
                </Box>
            ))}
        </Box>
    );
}

export default QcDetails;
